import { jsx as R } from "react/jsx-runtime";
import { AsyncDuckDB as W } from "@duckdb/duckdb-wasm";
import r from "react";
import { t as f, h as C, i as b, j as S } from "../instance-B0lHmJzq.js";
import { Resolvable as h } from "../utils/resolvable.js";
import { useDuckDBLogger as P, useDuckDBBundleResolver as j } from "./platformProvider.js";
const D = r.createContext(null), g = r.createContext(null), T = () => r.useContext(D), $ = () => r.useContext(g), z = (d) => {
  const m = P(), x = j(), [y, u] = r.useState(new h()), c = r.useRef(null), i = r.useRef(null), t = r.useRef(null), k = r.useRef(!1), p = r.useRef(null), w = r.useRef(!1);
  r.useEffect(() => (w.current = !1, () => {
    if (k.current) {
      w.current = !0;
      return;
    }
    const a = i.current, e = c.current;
    i.current = null, c.current = null, t.current = null, u(new h()), a ? a.dispose() : e && f(e);
  }), []);
  const B = r.useCallback(async () => {
    if (t.current) return await t.current;
    const a = {};
    return p.current = a, k.current = !0, t.current = (async () => {
      let e = null;
      try {
        const o = await x();
        if (o == null)
          return t.current = null, u(
            (l) => l.failWith("Failed to resolve bundle")
          ), null;
        if (w.current)
          return t.current = null, u(new h()), null;
        let n;
        try {
          e = new Worker(o.mainWorker), C(e), c.current = e, n = new W(m, e);
        } catch (l) {
          return t.current = null, e && await f(e), c.current = null, u((s) => s.failWith(l)), null;
        }
        try {
          await n.instantiate(
            o.mainModule,
            o.pthreadWorker,
            d.enableProgress ? (l) => {
              try {
                u((s) => s.updateRunning(l));
              } catch (s) {
                console.warn(
                  `progress handler failed with error: ${s.toString()}`
                );
              }
            } : void 0
          ), d.config !== void 0 && await n.open(d.config);
        } catch (l) {
          return t.current = null, await f(e), c.current = null, u((s) => s.failWith(l)), null;
        }
        if (w.current) {
          t.current = null;
          try {
            await n.terminate();
          } finally {
            await f(e), c.current = null;
          }
          return u(new h()), null;
        }
        const v = b({ db: n, worker: e });
        return i.current = v, S(v), u((l) => l.completeWith(n)), n;
      } catch (o) {
        t.current = null;
        const n = i.current;
        return n ? (i.current = null, await n.dispose()) : e && await f(e), c.current = null, u((v) => v.failWith(o)), null;
      } finally {
        p.current === a && (k.current = !1);
      }
    })(), t.current;
  }, [m]);
  return /* @__PURE__ */ R(g.Provider, { value: B, children: /* @__PURE__ */ R(D.Provider, { value: y, children: d.children }) });
};
export {
  z as DuckDBBaseProvider,
  $ as useDuckDBResolver,
  T as useDuckDBSetupContext
};
